(function() {
  exports.Filter = function(parent, filter) {
    var ref, ref1, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, self;
    if (filter == null) {
      filter = {};
    }
    self = this;
    ko.bindingHandlers.element = {
      init: function(ele, valueAccessor, allBindings, viewModel, bindingContext) {
        return viewModel.ele = ele;
      }
    };
    this.enableFilter = function() {
      self.visible(true);
      return self.enabled(true);
    };
    this.disableFilter = function() {
      self.visible(false);
      return self.enabled(false);
    };
    this.assignDisplayName = function(name) {
      return self.display_name(name);
    };
    this.changeControlType = function(type, repopulate) {
      if (repopulate == null) {
        repopulate = true;
      }
      this.control_type = type;
      if (repopulate) {
        return this.populateSelectedValues(this.selected_values(), true);
      }
    };

    /*
    Fires when a value is clicked/selected in the filter list.
     */
    this.selectFilter = function(item, e, refresh) {
      if (refresh == null) {
        refresh = true;
      }
      if (item != null) {
        return self.applyFilter(item, refresh, e);
      }
    };

    /*
    Fires when a option is clicked/selected in the filter list.
     */
    this.selectOptionFilter = function(item, e, refresh) {
      if (refresh == null) {
        refresh = true;
      }
      if (item.disabled) {
        return;
      }
      if (self.deletable && item.extra_class() === 'active') {
        setTimeout((function() {
          return $(e.target).removeClass('active');
        }), 0);
        return self.unselectFilter(item);
      } else {
        return self.applyFilter(item, refresh, e);
      }
    };

    /*
    This is responsible for adding the filter to the selected_values list,
    as well as setting the visible attribute false on the original item so
    it is no longer listed in the actual list of filter values
     */
    this.applyFilter = function(item, allow_refresh, e) {
      var new_value, newitem, old_value, picker, val;
      if (allow_refresh == null) {
        allow_refresh = false;
      }
      if (e == null) {
        e = {};
      }
      if (item == null) {
        return;
      }
      newitem = {
        key: item.key,
        value: item.value,
        isSelectedInParent: ko.computed(function() {
          var s;
          s = self.findVal(item.key, self.values());
          if (s === false || self.values()[s].visible === false) {
            return false;
          }
          return true;
        }),
        filterColor: ko.computed(function() {
          var c;
          c = self.findVal(item.value, self.colors);
          if (c !== false) {
            return self.colors[c].color;
          } else {
            return '';
          }
        })
      };
      if (self.control_type === 'datepicker') {
        self.selected_values.removeAll();
        if ((item.key != null) && (item.value != null)) {
          val = item.key;
        } else if (e.target != null) {
          val = $(e.target).val();
        }
        if (val) {
          self.selected_values.push({
            key: val,
            value: val,
            isSelectedInParent: function() {
              return true;
            },
            filterColor: function() {
              var c;
              c = self.findVal(item.value, self.colors);
              if (c !== false) {
                return self.colors[c].color;
              } else {
                return '';
              }
            }
          });
        }
      }
      if (self.control_type === 'daterangepicker') {
        picker = allow_refresh;
        self.selected_values.removeAll();
        self.selected_values.push({
          key: JSON.stringify({
            start: picker.startDate.format(),
            end: picker.endDate.format()
          }),
          value: (picker.startDate.format('MM/DD')) + " to " + (picker.endDate.format('MM/DD')),
          isSelectedInParent: function() {
            return true;
          },
          filterColor: function() {
            var c;
            c = self.findVal(item.value, self.colors);
            if (c) {
              return self.colors[c].color;
            } else {
              return '';
            }
          }
        });
      } else if (self.control_type === 'text') {
        self.selected_values.removeAll();
        if ((item.key != null) && (item.value != null)) {
          val = item.key;
        } else if (e.target != null) {
          val = $(e.target).val();
        }
        if (val) {
          self.selected_values.push({
            key: val,
            value: val,
            isSelectedInParent: function() {
              return true;
            },
            filterColor: function() {
              return '';
            }
          });
        }
      } else if (self.control_type === 'dropdown') {
        if (self.findVal(item.key, self.selected_values()) === false) {
          self.selected_values.push(newitem);
        }
      } else if (self.control_type === 'single_dropdown') {
        self.selected_values.removeAll();
        self.selected_values.push(newitem);
      } else if (self.control_type === 'option') {
        if (self.selected_values().length > 0) {
          old_value = self.findVal(self.selected_values()[0].key, self.values());
          if (old_value) {
            self.values()[old_value].extra_class('');
          }
          self.selected_values.removeAll();
        }
        self.selected_values.push(newitem);
        new_value = self.findVal(item.key, self.values());
        if (new_value !== false) {
          self.values()[new_value].extra_class('active');
        }
      }
      if (self.onFilterApplied != null) {
        self.onFilterApplied(self, self.selected_values);
      }
      if (allow_refresh) {
        return parent.fetchFilters();
      }
    };

    /*
    Fires when a value is selected to be removed from the applied filters.
    
    This is responsible for removing the clicked item from selected_values,
    and un-hiding the value back in the actual list of filter values (if it is still in the list)
     */
    this.unselectFilter = function(item) {
      var value;
      if (self.control_type === 'option') {
        value = self.findVal(item.key, self.values());
        if (value !== false) {
          self.values()[value].extra_class('');
        }
        self.selected_values.removeAll();
      }
      self.selected_values.remove(item);
      if (self.refresh_on_delete === true) {
        return parent.fetchFilters();
      }
    };

    /*
    Quick shortcut/utility method for finding a value in any of our arrays,
    by some kind of object key.
     */
    this.findVal = function(key, arr, attr) {
      var i, k, len, v;
      if (attr == null) {
        attr = 'key';
      }
      for (k = i = 0, len = arr.length; i < len; k = ++i) {
        v = arr[k];
        if (v[attr] === key) {
          return k;
        }
      }
      return false;
    };

    /*
    Ensures filter values are populated correctly
     */
    this.populateValues = function(vals) {
      $.each(vals, function(index, v) {
        var selected_item;
        v.visible = ko.computed(function() {
          return self.findVal(v.key, self.selected_values()) === false;
        });
        v.filterColor = ko.computed(function() {
          var c;
          c = self.findVal(v.key, self.colors);
          if (c !== false) {
            return self.colors[c].color;
          } else {
            return '';
          }
        });
        v.extra_class = ko.observable('');
        if (self.control_type === 'option') {
          selected_item = self.findVal(v.key, self.selected_values());
          if (selected_item !== false) {
            if (v.disabled) {
              self.unselectFilter(selected_item);
            } else {
              v.extra_class('active');
            }
          }
        }
        if (v.disabled) {
          return v.extra_class('disabled');
        }
      });
      self.values.removeAll();
      ko.utils.arrayPushAll(self.values(), vals);
      return self.values.valueHasMutated();
    };

    /*
    Can be used to populate defaults
     */
    this.populateSelectedValues = function(vals, refresh) {
      var i, len, results, v;
      if (refresh == null) {
        refresh = true;
      }
      results = [];
      for (i = 0, len = vals.length; i < len; i++) {
        v = vals[i];
        results.push(self.selectFilter(v, {}, refresh));
      }
      return results;
    };

    /*
    On construction
     */
    self.name = (ref = filter.name) != null ? ref : '';
    self.display_name = ko.observable((ref1 = filter.display_name) != null ? ref1 : '');
    self.control_type = (ref2 = filter.control_type) != null ? ref2 : 'dropdown';
    self.auto_select_only_value = (ref3 = filter.auto_select_only_value) != null ? ref3 : false;
    self.auto_select_first = (ref4 = filter.auto_select_first) != null ? ref4 : false;
    self.auto_clear_unavailable = (ref5 = filter.auto_clear_unavailable) != null ? ref5 : false;
    self.auto_select_by_default_flag = (ref6 = filter.auto_select_by_default_flag) != null ? ref6 : false;
    self.force_select_an_option = (ref7 = filter.force_select_an_option) != null ? ref7 : false;
    self.deletable = (ref8 = filter.deletable) != null ? ref8 : true;
    self["class"] = ko.observable((ref9 = filter["class"]) != null ? ref9 : '');
    self.colors = (ref10 = filter.colors) != null ? ref10 : [];
    self.values = ko.observableArray();
    self.enable_depends = (ref11 = filter.enable_depends) != null ? ref11 : true;
    self.visible_depends = (ref12 = filter.visible_depends) != null ? ref12 : true;
    self.visible = ko.observable((ref13 = filter.visible) != null ? ref13 : true);
    self.enabled = ko.observable((ref14 = filter.enable) != null ? ref14 : true);
    self.refresh_on_delete = (ref15 = filter.refresh_on_delete) != null ? ref15 : true;
    if (filter.listenForYear != null) {
      self.listenForYear = filter.listenForYear;
    }
    if (filter.onFilterApplied != null) {
      self.onFilterApplied = filter.onFilterApplied;
    }
    self.selected_values = ko.observableArray();
    self.populateValues((ref16 = filter.values) != null ? ref16 : []);
    self.populateSelectedValues((ref17 = filter.selected_values) != null ? ref17 : [], false);
    self.anyVisible = ko.computed(function() {
      var i, len, ref18, v;
      ref18 = self.values();
      for (i = 0, len = ref18.length; i < len; i++) {
        v = ref18[i];
        if (v.visible()) {
          return true;
        }
      }
      return false;
    });
    this.VisDep = ko.computed(function() {
      var f, i, j, len, len1, ref18, ref19, sv;
      if (Array.isArray(self.visible_depends)) {
        ref18 = self.visible_depends;
        for (i = 0, len = ref18.length; i < len; i++) {
          f = ref18[i];
          filter = parent.findInGroup(f.key);
          if (!filter) {
            return true;
          }
          ref19 = filter.selected_values();
          for (j = 0, len1 = ref19.length; j < len1; j++) {
            sv = ref19[j];
            if (sv.value !== f.value) {
              if (self.control_type === 'datepicker') {
                self.selected_values.removeAll();
              }
              return false;
            }
          }
        }
        return true;
      } else {
        return self.visible_depends;
      }
    });
    this.EnableDep = ko.computed(function() {
      var f, i, j, len, len1, ref18, ref19, sv;
      if (Array.isArray(self.enable_depends)) {
        ref18 = self.enable_depends;
        for (i = 0, len = ref18.length; i < len; i++) {
          f = ref18[i];
          filter = parent.findInGroup(f.key);
          if (!filter) {
            return true;
          }
          ref19 = filter.selected_values();
          for (j = 0, len1 = ref19.length; j < len1; j++) {
            sv = ref19[j];
            if (sv.value !== f.value) {
              if (self.control_type === 'datepicker') {
                self.selected_values.removeAll();
              }
              return false;
            }
          }
        }
        return true;
      } else {
        return self.enable_depends;
      }
    });

    /*
    self.fetch = () ->
        if $.isArray self.source
            self.value(self.source)
     */
    return self;
  };

}).call(this);
